/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const GET_OFFERS = "GET_OFFERS";
export const GET_OFFERS_SUCCESS = "GET_OFFERS_SUCCESS";
export const GET_OFFERS_FAILURE = "GET_OFFERS_FAILURE";

export const GET_PAYMENT_INVOICES = "GET_PAYMENT_INVOICES";
export const GET_PAYMENT_INVOICES_SUCCESS = "GET_PAYMENT_INVOICES_SUCCESS";
export const GET_PAYMENT_INVOICES_FAILURE = "GET_PAYMENT_INVOICES_FAILURE";
